import { NAME_MATCHES, NO_NULL_UUID_MATCH } from '@uplift/constants';
import { l10nEnService } from '@uplift/services';
import { AddressType, YesNo } from '@uplift/types';
import { createDobFieldValidation, settingsAddressValidation } from '@uplift/ui-v2';
import { VALIDATION_INSURANCE_GROUP_NUMBER, VALIDATION_INSURANCE_SUBSCRIBER_ID } from '@uplift/validations';
import { object, string, mixed } from 'yup';

export type InsuranceInfoFormValues = {
  isPrimarySubscriber: YesNo;
  insuranceProvider: string;
  memberId: string;
  groupNumber: string;
  insuranceCardFront: string | null;
  insuranceCardBack: string | null;
  primarySubscriberFirstName?: string;
  primarySubscriberLastName?: string;
  primarySubscriberDateOfBirth?: string | null;
  address?: AddressType;
};

export const insuranceInfoValidation = (l10n: typeof l10nEnService) =>
  object({
    isPrimarySubscriber: mixed<YesNo>()
      .required()
      .oneOf([ YesNo.Yes, YesNo.No ]),
    insuranceProvider: string()
      .matches(NO_NULL_UUID_MATCH, l10n.validations.insurance)
      .required(l10n.validations.insurance),
    memberId: VALIDATION_INSURANCE_SUBSCRIBER_ID,
    groupNumber: VALIDATION_INSURANCE_GROUP_NUMBER,
    insuranceCardFront: mixed().required(l10n.validations.insuranceCardFront),
    insuranceCardBack: mixed().required(l10n.validations.insuranceCardBack),
    primarySubscriberFirstName: string()
      .when('isPrimarySubscriber', {
        is: YesNo.No,
        then: s => s
          .matches(NAME_MATCHES, l10n.validations.nameMatches)
          .max(64, l10n.validations.lengthMatches(1, 64))
          .required(l10n.validations.primarySubFirstName)
      }),
    primarySubscriberLastName: string().notRequired()
      .when('isPrimarySubscriber', {
        is: YesNo.No,
        then: s => s
          .matches(NAME_MATCHES, l10n.validations.nameMatches)
          .max(64, l10n.validations.lengthMatches(1, 64))
          .required(l10n.validations.primarySubLastName)
      }),
    primarySubscriberDateOfBirth: mixed().nullable().notRequired()
      .when('isPrimarySubscriber', {
        is: YesNo.No,
        then: _s => createDobFieldValidation(l10n, { adult: true }),
      }),
    address: mixed()
      .when('isPrimarySubscriber', {
        is: YesNo.No,
        then: _s => settingsAddressValidation(l10n),
      }),
  });
